import React, { useState, useEffect } from 'react';
import WhatsAppCourseCard from '../../components/whatsappclass/WhatsAppCourseCard';
import RegistrationModal from '../../components/whatsappclass/RegistrationModal';
import { Helmet } from 'react-helmet';
import whatsappclass from '../../components/assets/whatsappclass.jpg';

const SEO_CONFIG = {
  title: "WhatsApp Export Class | Professional Export Courses Nigeria",
  description: "Learn export business via WhatsApp with our professional training programs. Courses in foodstuff export, buyer sourcing, documentation, and more. Start with ₦15,000.",
  keywords: "WhatsApp export training, Nigeria export courses, online export training, foodstuff export course, international trade WhatsApp classes, export documentation training, mini exporting course",
  canonicalUrl: "https://lsem.org.ng/whatsappclass",
  imageUrl: whatsappclass,
};

const whatsappCourses = [
  {
    id: 'foodstuff-export',
    title: 'Foodstuffs Export',
    description: 'Master the essentials of exporting Nigerian foodstuffs (garri, beans, plantains) to international markets. Learn NAFDAC certification, packaging, and buyer acquisition.',
    price: '₦20,000',
    hours: 4,
    students: 250,
    rating: 4.8,
    image: 'https://images.unsplash.com/photo-1509358271058-acd22cc93898?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
    whatsappLink: 'https://wa.me/c/2349058681595',
    seoDescription: 'Professional WhatsApp course on foodstuff export from Nigeria to Europe, US & Canada. Learn certification, packaging, and market entry strategies.'
  },
    {
    id: 'mini-exporting',
    title: 'Mini Exportation',
    description: 'Learn how to start small-scale export operations with minimal capital investment.',
    price: '₦15,000',
    hours: 3,
    students: 180,
    rating: 4.7,
    image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
    whatsappLink: 'https://wa.me/c/2349058681595'
  },
  {
    id: 'buyer-sourcing',
    title: 'Buyer Sourcing',
    description: 'Discover strategies for finding and connecting with international buyers.',
    price: '₦25,000',
    hours: 5,
    students: 320,
    rating: 4.9,
    image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
    whatsappLink: 'https://wa.me/c/2349058681595'
  },
  {
    id: 'incoterms-2020',
    title: 'INCOTERMS 2020',
    description: 'Comprehensive guide to understanding and applying International Commercial Terms.',
    price: '₦18,000',
    hours: 4,
    students: 200,
    rating: 4.6,
    image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
    whatsappLink: 'https://wa.me/c/2349058681595'
  },
  {
    id: 'export-documentation',
    title: 'Export Documentation',
    description: 'Master all essential documentation required for successful international trade.',
    price: '₦25,000',
    hours: 6,
    students: 280,
    rating: 4.8,
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
    whatsappLink: 'https://wa.me/c/2349058681595'
  },
  {
    id: 'export-financing',
    title: 'Export Financing',
    description: 'Learn about various financing options and strategies for export operations.',
    price: '₦30,000',
    hours: 4,
    students: 150,
    rating: 4.7,
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
    whatsappLink: 'https://wa.me/c/2349058681595'
  },
  {
    id: 'export-business-planning',
    title: 'Export Business Planning',
    description: 'Develop comprehensive business plans for successful export ventures.',
    price: '₦25,000',
    hours: 5,
    students: 220,
    rating: 4.9,
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
    whatsappLink: 'https://wa.me/c/2349058681595'
  },
  {
    id: 'foundation-commodities',
    title: 'Foundation in Commodities',
    description: 'Understanding commodity trading basics and international market dynamics.',
    price: '₦18,000',
    hours: 4,
    students: 190,
    rating: 4.6,
    image: 'https://images.unsplash.com/photo-1509358271058-acd22cc93898?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
    whatsappLink: 'https://wa.me/c/2349058681595'
  },
  {
  id: 'export-contract-analysis',
  title: 'Export Contract Analysis',
  description: 'Learn how to analyze and draft export contracts to avoid legal pitfalls and protect your interests.',
  price: '₦20,000',
  hours: 4,
  students: 160,
  rating: 4.7,
  image: 'https://www.technologyhq.org/wp-content/uploads/2022/12/Everything-you-need-know-about-contract-analysis-696x464.jpg',
  whatsappLink: 'https://wa.me/c/2349058681595'
},
{
  id: 'ai-buyer-sourcing',
  title: 'Buyer Sourcing in the Age of Artificial Intelligence',
  description: 'Explore how AI tools can help you find reliable international buyers quickly and efficiently.',
  price: '₦25,000',
  hours: 5,
  students: 210,
  rating: 4.8,
  image: 'https://imageio.forbes.com/specials-images/imageserve/643016813686d8eafca00875/0x0.jpg?format=jpg&width=1200',
  whatsappLink: 'https://wa.me/c/2349058681595'
},
{
  id: 'digital-marketing-exporters',
  title: 'Digital Marketing for Exporters',
  description: 'Learn how to use digital marketing tools to promote your export products and generate leads.',
  price: '₦18,000',
  hours: 4,
  students: 230,
  rating: 4.7,
  image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
  whatsappLink: 'https://wa.me/c/2349058681595'
},
{
  id: 'foundation-international-trade',
  title: 'Foundation in International Trade',
  description: 'Understand the fundamental principles of international trade and global market dynamics.',
  price: '₦15,000',
  hours: 3,
  students: 195,
  rating: 4.6,
  image: 'https://th.bing.com/th/id/OIP.CTr19elwVNKScENSAzUCaQHaHa?cb=iwp2&w=480&h=480&rs=1&pid=ImgDetMain',
  whatsappLink: 'https://wa.me/c/2349058681595'
},
{
  id: 'chatgpt-exporters',
  title: 'How to Use ChatGPT for Exporters',
  description: 'Unlock the power of ChatGPT for writing proposals, researching markets, and automating export tasks.',
  price: '₦15,000',
  hours: 3,
  students: 170,
  rating: 4.8,
  image: 'https://th.bing.com/th/id/R.d19dea407bdf0079aee9bea943b158fa?rik=ZGttSx17n4kSjw&pid=ImgRaw&r=0',
  whatsappLink: 'https://wa.me/c/2349058681595'
},
{
  id: 'export-desk-setup',
  title: 'How to Set Up Your Export Desk',
  description: 'Step-by-step guide to establishing an efficient export unit within your organization.',
  price: '₦18,000',
  hours: 4,
  students: 140,
  rating: 4.6,
  image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
  whatsappLink: 'https://wa.me/c/2349058681595'
},
{
  id: 'export-business-setup',
  title: 'How to Set Up Your Export Business',
  description: 'From registration to market research, get all the essentials for launching your export business.',
  price: '₦20,000',
  hours: 4,
  students: 185,
  rating: 4.7,
  image: 'https://th.bing.com/th/id/OIP.CTr19elwVNKScENSAzUCaQHaHa?cb=iwp2&w=480&h=480&rs=1&pid=ImgDetMain',
  whatsappLink: 'https://wa.me/c/2349058681595'
},
{
  id: 'export-logistics',
  title: 'Mastering Export Logistics',
  description: 'Learn how to manage shipping, customs, and freight forwarding for your export business.',
  price: '₦25,000',
  hours: 5,
  students: 210,
  rating: 4.8,
  image: 'https://th.bing.com/th/id/OIP.ucAbcJsOjH5DVwPVc5TNMAHaDf?cb=iwp2&rs=1&pid=ImgDetMain',
  whatsappLink: 'https://wa.me/c/2349058681595'
},
{
  id: 'intro-to-airfreight',
  title: 'Introduction to Airfreight',
  description: 'Understand how airfreight works and when to use it in your export operations.',
  price: '₦15,000',
  hours: 3,
  students: 130,
  rating: 4.6,
  image: 'https://th.bing.com/th/id/OIP.dkYAwZQSCsmyRmG6N2YeuAHaE7?cb=iwp2&rs=1&pid=ImgDetMain',
  whatsappLink: 'https://wa.me/c/2349058681595'
},
{
  id: 'export-quality-assurance',
  title: 'Quality Assurance in Export',
  description: 'Ensure your goods meet international quality standards and avoid returns or rejections.',
  price: '₦18,000',
  hours: 4,
  students: 150,
  rating: 4.7,
  image: 'https://th.bing.com/th/id/R.a67cccd3fdb0a2dd1524053fafc9dc91?rik=d9NkbeIhJ0AkFg&pid=ImgRaw&r=0',
  whatsappLink: 'https://wa.me/c/2349058681595'
},
{
  id: 'hair-products-export',
  title: 'Become a Hair Products Exporter',
  description: 'Tap into the booming global demand for African hair care products with this practical guide.',
  price: '₦20,000',
  hours: 4,
  students: 170,
  rating: 4.8,
  image: 'https://th.bing.com/th/id/OIP.aQgkZxtw44ed5jKCesLmHQHaE8?cb=iwp2&rs=1&pid=ImgDetMain',
  whatsappLink: 'https://wa.me/c/2349058681595'
},
{
  id: 'afcfta-leverage',
  title: 'How to Leverage AfCFTA for Your Business',
  description: 'Explore business opportunities under the African Continental Free Trade Area and how to benefit from them.',
  price: '₦22,000',
  hours: 5,
  students: 200,
  rating: 4.9,
  image: 'https://sbs.strathmore.edu/wp-content/uploads/2023/11/AfCFTA-A-Path-to-Prosperity-for-Africa.png',
  whatsappLink: 'https://wa.me/c/2349058681595'
}
];

const WhatsAppClassLayout = () => {
  const [selectedCourse, setSelectedCourse] = useState<{
    id: string;
    title: string;
    price: string;
  } | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Update document meta tags
    document.title = SEO_CONFIG.title;
    
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', SEO_CONFIG.description);
  }, []);

  const handleLearnMore = (courseId: string) => {
    const course = whatsappCourses.find(c => c.id === courseId);
    if (course?.whatsappLink) {
      window.open(course.whatsappLink, '_blank');
    }
  };

  const handleRegister = (courseId: string) => {
    const course = whatsappCourses.find(c => c.id === courseId);
    if (course) {
      setSelectedCourse({
        id: course.id,
        title: course.title,
        price: course.price
      });
      setIsModalOpen(true);
      // Track conversion event
      const gtag = window.gtag;
      if (typeof gtag === 'function') {
        gtag('event', 'conversion', {
          'send_to': 'AW-YOUR_CONVERSION_ID/ABC123',
          'value': course.price.replace('₦', ''),
          'currency': 'NGN',
          'transaction_id': course.id
        });
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      <Helmet>
        <title>{SEO_CONFIG.title}</title>
        <meta name="description" content={SEO_CONFIG.description} />
        <meta name="keywords" content={SEO_CONFIG.keywords} />
        <link rel="canonical" href={SEO_CONFIG.canonicalUrl} />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={SEO_CONFIG.canonicalUrl} />
        <meta property="og:title" content={SEO_CONFIG.title} />
        <meta property="og:description" content={SEO_CONFIG.description} />
        <meta property="og:image" content={SEO_CONFIG.imageUrl} />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={SEO_CONFIG.canonicalUrl} />
        <meta property="twitter:title" content={SEO_CONFIG.title} />
        <meta property="twitter:description" content={SEO_CONFIG.description} />
        <meta property="twitter:image" content={SEO_CONFIG.imageUrl} />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            "itemListElement": whatsappCourses.map((course, index) => ({
              "@type": "ListItem",
              "position": index + 1,
              "item": {
                "@type": "Course",
                "name": course.title,
                "description": course.seoDescription || course.description,
                "provider": {
                  "@type": "Organization",
                  "name": "Lagos School of Export Management",
                  "sameAs": "https://lsem.org.ng"
                },
                "offers": {
                  "@type": "Offer",
                  "price": course.price.replace('₦', ''),
                  "priceCurrency": "NGN"
                },
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": course.rating.toString(),
                  "ratingCount": course.students.toString()
                }
              }
            }))
          })}
        </script>
      </Helmet>

      {/* Hidden SEO content for crawlers */}
      <div className="sr-only">
        <h1>{SEO_CONFIG.title}</h1>
        <p>{SEO_CONFIG.description}</p>
        <h2>Available WhatsApp Export Courses</h2>
        <ul>
          {whatsappCourses.map(course => (
            <li key={course.id}>
              <h3>{course.title}</h3>
              <p>{course.seoDescription || course.description}</p>
              <p>Price: {course.price}</p>
              <p>Duration: {course.hours} hours</p>
            </li>
          ))}
        </ul>
      </div>

      <header role="banner" className="bg-blue-600 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-white text-center">
            WhatsApp Export Training Programs
          </h2>
          <p className="mt-4 text-xl text-blue-100 text-center max-w-3xl mx-auto">
            Professional export training delivered through WhatsApp. Learn at your own pace with expert guidance.
          </p>
        </div>
      </header>

      <main role="main" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <section aria-label="Available Export Courses">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {whatsappCourses.map((course) => (
              <article key={course.id} itemScope itemType="https://schema.org/Course">
                <WhatsAppCourseCard
                  title={course.title}
                  description={course.description}
                  price={course.price}
                  hours={course.hours}
                  image={course.image}
                  students={course.students}
                  rating={course.rating}
                  onRegister={() => handleRegister(course.id)}
                  onLearnMore={() => handleLearnMore(course.id)}
                />
              </article>
            ))}
          </div>
        </section>
      </main>

      {selectedCourse && (
        <RegistrationModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          course={selectedCourse}
        />
      )}
    </div>
  );
};

export default WhatsAppClassLayout;